import { IComparisonToastPayload } from 'shared/map-search/types/comparisonToast';
import { ITypedReduxAction } from 'shared/map-search/types/redux/actionType';

export enum EComparisonToastActionType {
  Show = 'comparisonToast/show',
}

export type TComparisonToastShow = ITypedReduxAction<EComparisonToastActionType.Show, IComparisonToastPayload>;

export type TComparisonToastActions = TComparisonToastShow;
